"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleThemeIcon = void 0;
var react_1 = __importDefault(require("react"));
var ToggleThemeIcon = function (_a) {
    var color = _a.color;
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M0 12C0 18.3623 5.15766 23.52 11.52 23.52C17.8823 23.52 23.04 18.3623 23.04 12C23.04 5.63769 17.8823 0.47998 11.52 0.47998C5.15771 0.47998 0 5.63764 0 12ZM11.52 20.5471V3.45288C16.2444 3.45288 20.0671 7.27636 20.0671 12C20.0671 16.7243 16.2436 20.5471 11.52 20.5471Z", fill: color })));
};
exports.ToggleThemeIcon = ToggleThemeIcon;
